import { AxiosInstance } from 'axios';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const addHeader = (instance: AxiosInstance, headerName: string, value: any): void => {
    Object.assign(instance.defaults, { headers: { [headerName]: value, ...instance.defaults.headers } });
};
